import { createLucideIcon } from 'lucide-react';
export const CalendarDropdownIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M13 12H15',
      key: '8yhgey',
    },
  ],
  [
    'path',
    {
      d: 'M13 15H15',
      key: 'w4ks71',
    },
  ],
  [
    'path',
    {
      d: 'M13 18H15',
      key: 'jktvdc',
    },
  ],
  [
    'path',
    {
      d: 'M16 3V5',
      key: 'k8r3mo',
    },
  ],
  [
    'path',
    {
      d: 'M17 12H19',
      key: '3wroeq',
    },
  ],
  [
    'path',
    {
      d: 'M17 15H19',
      key: '15y3n3',
    },
  ],
  [
    'path',
    {
      d: 'M3 22.0232V4.02324H21V22.0232H3Z',
      key: '1anbz1',
    },
  ],
  [
    'path',
    {
      d: 'M3 8H21',
      key: '1iukdm',
    },
  ],
  [
    'path',
    {
      d: 'M5 15H7',
      key: 'bmf4m1',
    },
  ],
  [
    'path',
    {
      d: 'M5 18H7',
      key: 'l3du8k',
    },
  ],
  [
    'path',
    {
      d: 'M8 3V5',
      key: 'qp83q7',
    },
  ],
  [
    'path',
    {
      d: 'M9 12H11',
      key: 'p54hgl',
    },
  ],
  [
    'path',
    {
      d: 'M9 15H11',
      key: '1ed0ec',
    },
  ],
  [
    'path',
    {
      d: 'M9 18H11',
      key: 'gd1ii7',
    },
  ],
]);
